export default __webpack_public_path__ + "static/media/second-slide-image.cad3ed85.png";